import { mixins } from 'vue-class-component'
import { Component, Watch } from 'vue-property-decorator'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import { showErrors, showNotification } from '@/utils/snack'
import AppSelector from '@/components/AppSelector.vue'
import { caseType } from '@/modules/Newcase/helpers/case'

import AppTextSearchOrInput from '@/components/AppTextSearchOrInput.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import SearchAccount from '@/mixins/search-queries/search-account'
import { Account } from '@/modules/Account/interfaces/account'
import AccountForm from '@/modules/Account/components/AccountForm.vue'
import AccountDialog from '@/modules/Account/scripts/account-dialog'
import { RecordType, RecordTypeMaster } from '@/modules/RecordType/interfaces/record-type'
import RecordTypesHandler from '@/mixins/record-types'
import { newCase } from '../gql/case.gql'
import { SnackType } from '@/interfaces/snack'

@Component({
  components: {
    AppTextSearchOrInput,
    AppSelector,
    AppBreadcrumbs,
    AccountForm,
    AppTextSearch
  }
})
export default class CaseCreate extends mixins(SearchAccount, AccountDialog, RecordTypesHandler) {
  breadcrumbs: Breadcrumb[] = [
    {
      text: 'Insurance Cases'
    },
    {
      text: 'Case'
    }
  ]

  account: Account | null = null

  typeIndex = -1

  recordType: RecordType = {} as RecordType

  showCreateBtn = true

  accountId = -1

  filterTypes: RecordType[] = []

  get accountName () {
    return this.account ? this.account.name : null
  }

  mounted () {
    this.getRecordTypes(RecordTypeMaster.POLICY)
  }

  @Watch('account')
  onAccountChanged (val: Account | null) {
    if (!val || !val.id) {
      this.accountId = -1
    } else {
      this.accountId = val.id
    }
  }

  searchRecordTypes (val?: string) {
    this.filterTypes = this.recordTypes.filter(item => item.name.toLowerCase().indexOf(val || '') !== -1)
  }

  selectAccountHandler (val: Account) {
    // do nothing
  }

  onAccountName (name:string) {
    this.account = {
      id: -1,
      name
    } as Account
  }

  onCreateAccount () {
    setTimeout(() => {
      this.accountDialog.show = true
    }, 500)
  }

  onCreateSuccess (accountId: number) {
    if (this.account) {
      this.account.id = accountId
      this.accountId = accountId
      this.createCaseConfirm()
    }
  }

  async createCaseConfirm () {
    if (this.accountId === -1) {
      this.accountDialog.show = true
      return
    }

    if (!this.recordType.id) {
      showNotification({
        msg: 'Please Select Record Type!',
        type: SnackType.Error
      })
      return
    }

    const type = caseType['NEW_BUSINESS']
    const year = this.$moment.tz('America/New_York').year()
    const inquiryName = `${this.accountName}-${this.recordType.name}-Case-${type}-${year}`

    try {
      const res = await this.$apollo.mutate({
        mutation: newCase,
        variables: {
          caseInput: {
            inquiryName,
            type: 'NEW_BUSINESS',
            recordTypeId: +this.recordType.id,
            accountId: +this.accountId
          }
        }
      })

      const caseId = res.data.newCase.id

      this.$router.push({
        name: 'NewcaseDetail',
        params: {
          id: caseId + ''
        }
      })
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
